import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { Outlet } from 'react-router-dom';

export default function DashboardLayout() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-950 text-slate-100 md:grid md:grid-cols-[auto_1fr]">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(56,189,248,0.16),transparent_55%),radial-gradient(circle_at_bottom_right,rgba(16,185,129,0.18),transparent_60%),radial-gradient(circle_at_center,rgba(14,116,144,0.12),transparent_65%)]" />
      <div className="relative z-10 hidden md:block">
        <Sidebar />
      </div>
      <div className="relative z-10 flex min-h-0 flex-col overflow-hidden">
        <Header />
        <main className="flex min-h-0 flex-1 flex-col overflow-hidden p-2 md:p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
